/* Stylesheet */

.cohort_name {
  margin: 32px 0px 0px 0px;
}
